import {
    Grid,
    Typography,
    Card,
    CardContent,
    Box,
    Button,
} from "@mui/material";
import { CloudUpload } from "@mui/icons-material";
import { createBlobInContainer } from "src/utils/azureBlob";

const imageTypes = [
    { key: "box", label: "Box", dimensions: "160x160" },
    { key: "feature", label: "Feature", dimensions: "256x196" },
    { key: "vert", label: "Vert", dimensions: "160x210" },
    { key: "bigBox", label: "Big Box", dimensions: "250x250" },
    { key: "fullBox", label: "Full Box", dimensions: "345x345" },
];

export default function GameProviderImages({
    gameProvider,
    language = 'en',
    onChange,
}) {

    const uploadFiles = (event) => {
        if (event.target.files.length > 0) {
            const file = event.target.files[0];
            const imageType = event.target.dataset.imageType;
            if (!file || !imageType) return;
            const validTypes = ["image/jpeg", "image/jpg", "image/png", "image/webp", "image/gif"];
            const maxSize = 2 * 1024 * 1024;

            if (!validTypes.includes(file.type)) {
                alert("Only JPG, JPEG, PNG, WEBP, and GIF formats are allowed.");
                event.target.value = null;
                return;
            }

            if (file.size > maxSize) {
                alert("File size should not exceed 2MB.");
                event.target.value = null;
                return;
            }
            const newFileName = file.name.replace(/\s+/g, "_");

            const extension = newFileName.substring(newFileName.lastIndexOf("."));
            const safeFileName = `image_${Date.now()}${extension}`;

            const renamedFile = new File([file], safeFileName, { type: file.type });

            const uploadFilesAsync = async () => {
                try {
                    await createBlobInContainer(renamedFile);
                    const containerName = process.env.REACT_APP_STORAGE_CONTAINER;
                    const storageAccountName = process.env.REACT_APP_STORAGERESOURCENAME;
                    const imageUrl = `https://${storageAccountName}.blob.core.windows.net/${containerName}/${renamedFile.name}`;

                    // Update imagesI18n for the current language
                    const currentImagesI18n = gameProvider?.imagesI18n || {};
                    const currentLanguageImages = currentImagesI18n[language] || [];
                    const filteredImages = currentLanguageImages.filter(
                        (img) => img.imageType !== imageType
                    );

                    const updatedGameProvider = {
                        ...gameProvider,
                        imagesI18n: {
                            ...currentImagesI18n,
                            [language]: [...filteredImages, { imageType, imageUrl }],
                        },
                    };

                    onChange && onChange(updatedGameProvider);
                } catch (err) {
                    console.error(err);
                } finally {
                    event.target.value = null;
                }
            };

            uploadFilesAsync();
        }
    };


    // Get images for current language
    const getCurrentLanguageImages = () => {
        return gameProvider?.imagesI18n?.[language] || [];
    };

    // With card wrapper
    return (
        <Grid container spacing={3}>
            {imageTypes.map((imageType, index) => (
                <Grid item xs={12} sm={6} md={index > 2 ? 3 : 2} key={imageType.key}>
                    <Card variant="outlined" sx={{ height: "100%" }}>
                        <CardContent sx={{ textAlign: "center" }}>
                            <Typography variant="subtitle2" gutterBottom>
                                {imageType.label}
                            </Typography>
                            <Box
                                sx={{
                                    width: "100%",
                                    height: 120,
                                    backgroundColor: "#f5f5f5",
                                    border: "1px dashed #ccc",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    mb: 2,
                                    overflow: "hidden",
                                    borderRadius: 1,
                                }}
                            >
                                {getCurrentLanguageImages().find(
                                    (img) => img.imageType === imageType.key
                                )?.imageUrl ? (
                                    <img
                                        src={
                                            getCurrentLanguageImages().find(
                                                (img) => img.imageType === imageType.key
                                            ).imageUrl
                                        }
                                        alt="Uploaded"
                                        style={{
                                            maxWidth: "100%",
                                            maxHeight: "100%",
                                            objectFit: "contain",
                                        }}
                                    />
                                ) : (
                                    <Box
                                        sx={{
                                            display: "flex",
                                            gap: 1,
                                            flexDirection: "column",
                                            alignItems: "center",
                                        }}
                                    >
                                        <CloudUpload sx={{ fontSize: 40, color: "#ccc" }} />
                                        <Typography variant="caption" color="textSecondary">
                                            {imageType?.dimensions}
                                        </Typography>
                                    </Box>
                                )}
                            </Box>
                            <input
                                accept="image/*"
                                style={{ display: "none" }}
                                id={`upload-${imageType.key}`}
                                type="file"
                                hidden
                                data-image-type={imageType.key}
                                onChange={uploadFiles}
                            />
                            <label htmlFor={`upload-${imageType.key}`}>
                                <Button
                                    variant="outlined"
                                    component="span"
                                    size="small"
                                    fullWidth
                                >
                                    Upload Image
                                </Button>
                            </label>
                        </CardContent>
                    </Card>
                </Grid>
            ))}
        </Grid>
    );
}
